const messages = {
    accountBox: {
        title: "Dashboard",
        description: "Hier kunt u uw huidige puntensaldo en de transacties op uw account bekijken.",
        button: "DASHBOARD OPENEN",
    }
};

export default {
    messages,
};
